// This index describes the panels each component will live in

const residentPersonalInfoPanel = {
	component: async () => import("./ResidentPersonalInfo"),
	icon: "fa-user",
	title: "Personal Information",
	key: "residentPersonalInfo",
};
const moreInfoPanel = {
	component: async () => import("./MoreInfo"),
	icon: "fa-info-circle",
	title: "More Information",
	key: "moreInfo",
};
const preferencesPanel = {
	component: async () => import("./Preferences"),
	icon: "fa-cog",
	title: "Preferences",
	key: "preferences",
};
const rolesPanel = {
	component: async () => import("./RolesWrapper"),
	icon: "fa-key",
	title: "Roles and Pemissions",
	key: "roles",
};
const advancedPanel = {
	component: async () => import("./Advanced"),
	icon: "far fa-list-alt",
	title: "Advanced",
	key: "advanced",
};
const staffPersonalInfoPanel = {
	component: async () => import("./StaffPersonalInfo"),
	icon: "fa-id-badge",
	title: "Staff Info",
	key: "staffPersonalInfo",
};
const contactPersonalInfoPanel = {
	component: async () => import("./ContactPersonalInfo"),
	icon: "fa-user-friends",
	title: "Contact Info",
	key: "contactPersonalInfo",
};

export {
	residentPersonalInfoPanel,
	moreInfoPanel,
	preferencesPanel,
	rolesPanel,
	advancedPanel,
	staffPersonalInfoPanel,
	contactPersonalInfoPanel,
};
